import { MarketingBottomCta } from "../components/MarketingBottomCta";
import { HubTopicCardGrid } from "../components/HubTopicCardGrid";
import { Zap, Search, Volume2 } from "lucide-react";
import { Link } from "react-router";
import { Seo } from "../components/Seo";
import { buildSolutionHubGroups } from "../data/navMenus";

const solutionHubGroups = buildSolutionHubGroups();

export function Solutions() {
  return (
    <>
      <Seo
        title="Solutions"
        description="Desktop session recording solutions for disputes, forensic audits, root cause analysis, SOP adherence, regulatory defense, incident response, vendor assurance, workplace integrity, and content safety."
        canonicalPath="/solutions"
      />
      <div className="bg-slate-950 min-h-screen">
        <section className="relative pt-36 pb-16 overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(13, 148, 136, 0.15) 0%, transparent 60%)",
            }}
          />
          <div
            className="absolute inset-0 opacity-[0.03]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(148, 163, 184, 1) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 1) 1px, transparent 1px)",
              backgroundSize: "64px 64px",
            }}
          />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <span
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-teal-500/25 bg-teal-500/5 text-teal-400 text-xs uppercase tracking-widest mb-8"
              style={{ fontWeight: 600 }}
            >
              <Zap size={12} />
              Solutions & Use Cases
            </span>
            <h1
              className="text-slate-100 mb-6"
              style={{
                fontSize: "clamp(2rem, 4.5vw, 3.5rem)",
                fontWeight: 800,
                letterSpacing: "-0.03em",
                lineHeight: "1.1",
              }}
            >
              Purpose-built for{" "}
              <span
                style={{
                  background: "linear-gradient(135deg, var(--color-teal-500, #14b8a6) 0%, var(--color-emerald-500, #10b981) 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                high-stakes workflows.
              </span>
            </h1>
            <p className="text-on-dark-muted text-lg max-w-2xl mx-auto leading-relaxed">
              Choose a workflow below. Each solution opens on its own page with use cases, benefits, and deployment
              guidance.
            </p>
          </div>
        </section>

        {/* Compact capability strip */}
        <section className="pb-8 border-b border-slate-800/50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-teal-500/20 bg-teal-500/5">
                <Search size={13} className="text-teal-400 shrink-0" />
                <p className="text-on-dark-muted text-xs leading-none">
                  <span className="text-teal-300 font-semibold">Pro:</span>{" "}
                  Basic OCR and Chat with Your Recordings extend every solution.{" "}
                  <Link to="/features#ai-intelligence" className="text-teal-400 hover:text-teal-300 font-medium underline-offset-2 hover:underline">
                    See AI features
                  </Link>
                </p>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-emerald-500/20 bg-emerald-500/5">
                <Volume2 size={13} className="text-emerald-400 shrink-0" />
                <p className="text-on-dark-muted text-xs leading-none">
                  <span className="text-emerald-300 font-semibold">Session Audio</span>{" "}
                  and{" "}
                  <span className="text-violet-300 font-semibold">Webcam Capture</span>{" "}
                  optional add-ons on Pro+ endpoint pools.{" "}
                  <Link to="/pricing#session-audio-addon" className="text-teal-400 hover:text-teal-300 font-medium underline-offset-2 hover:underline">
                    Module pricing
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>

        <HubTopicCardGrid
          groups={solutionHubGroups}
          sectionTitle="All solutions"
          sectionSubtitle="Desktop session recording workflows for monitoring, security, and team coaching. CCTV+ items are optional add-ons purchased separately."
        />

        <MarketingBottomCta
          titleBefore="Ready to secure, monitor, and coach your team "
          titleAccent="from one platform?"
          description="Talk to a solutions architect about your specific workflow risks. We'll design a deployment that fits your infrastructure, compliance posture, and operational needs."
        />
      </div>
    </>
  );
}
